import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiColumnsContainerBaseDirective } from '@fi-shared/fi-two-columns-container/fi-columns-container-base.directive';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-three-columns-container',
    template: `
        <div class="fi-three-columns-content-wrapper" #columnsContainer cdkScrollable>
            <div class="fi-three-columns-left-content" #leftSideContainer>
                <ng-content select="left-content" />
            </div>
            <div class="fi-three-columns-center-content" #centerContainer>
                <ng-content select="center-content" />
            </div>
            <div class="fi-three-columns-right-content right-side" #rightSideContainer>
                <ng-content select="right-content" />
            </div>
        </div>
    `,
    styleUrl: './fi-three-columns-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-three-columns-container' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiThreeColumnsComponent }],
    standalone: false,
})
export class FiThreeColumnsComponent extends FiColumnsContainerBaseDirective {}
